import React from "react";

const Section = ({ id, title, lead, children, className = "" }) => (
  <section id={id} className={`provider-beta__section ${className}`.trim()}>
    {title ? <h2 className="provider-beta__section-title">{title}</h2> : null}
    {lead ? <p className="provider-beta__section-lead">{lead}</p> : null}
    {children}
  </section>
);

export default Section;
